import { createFileRoute } from "@tanstack/react-router"

import { FolderOwnershipPanel } from "@/pages/FolderOwnershipPanel"

export const Route = createFileRoute("/administration/folder-ownership")({
  component: FolderOwnershipPanel,
})
